"use client";

import React, { useState } from "react";
import VideoCard from "@/revamp/organisms/VideoCard/VideoCard";
import { Testimonials } from "@/data/data";
import styles from "@/revamp/sections/StudentTestimonial/StudentTestimonial.module.scss";
import Carousel from "@/components/molecules/Carousels/Carousel";

export default function VideoWrapper({
  isMobile
}) {
  const [activeVideoId, setActiveVideoId] = useState<string | null>(null);
  const Slides = Testimonials.map((testimonial, index) => (
    <VideoCard
      key={index}
      id={`${index+1}`}
      testimonial = {testimonial}
      activeVideoId={activeVideoId}
      ssetActiveVideoId={setActiveVideoId}
      isMobile={isMobile}
    />
  ));
  return (
    <>
    {/* {isMobile ? ( */}
          <Carousel
            slides={Slides}
            className="Carousel__bottom_only Carousel__hAuto"
            config={{
              pagination: {
                clickable: true,
              },
              spaceBetween: 16,
              slidesPerView: 2,
              autoplay: false,
              grid: {
                rows: 1,
                fill: "row",
              },
              breakpoints: {
                0: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                  grid: {
                    rows: 1,
                    fill: "row",
                  }
                },
                481: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                  grid: {
                    rows: 1,
                    fill: "row",
                  }
                },
                769: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                  grid: {
                    rows: 1,
                    fill: "row",
                  }
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                  grid: {
                    rows: 1,
                    fill: "row",
                  }
                },
                1440: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                  grid: {
                    rows: 1,
                    fill: "row",
                  }
                },
                1900: {
                  slidesPerView: 4,
                  spaceBetween: 100,
                  grid: {
                    rows: 1,
                    fill: "row",
                  }
                }
              },
            }}
          />
          
        {/* ) : (
          <div className={styles.grid}>
            {Slides}
          </div>
        )} */}
    
    </>
  );
}
